import { CheckboxField, Text } from '../../common/components';
import { t } from '../../common/i18n';

const namespace = 'Deadlines';

interface DeadlineNotificationSettingProps {
  enabled: boolean | null;
  onChange: (enabled: boolean) => void;
}

/** Per-admin nastavení e-mailových upozornění (null = ještě se načítá). */
export const DeadlineNotificationSetting: React.FC<DeadlineNotificationSettingProps> = ({ enabled, onChange }) => {
  if (enabled === null) return null;

  return (
    <div className="DeadlineNotificationSetting">
      <CheckboxField
        name="deadline-notifications"
        variant="switch"
        label={t('notificationSetting.label', namespace)}
        checked={enabled}
        onChange={() => onChange(!enabled)}
      />
      <Text as="div" size="body-small" color="Neutral600" className="DeadlineNotificationSetting__note">
        {t('notificationSetting.note', namespace)}
      </Text>
    </div>
  );
};

export default DeadlineNotificationSetting;
